import { render, staticRenderFns } from "./RequestViewTabRelated.vue?vue&type=template&id=21fb20e0"
import script from "./RequestViewTabRelated.vue?vue&type=script&lang=js"
export * from "./RequestViewTabRelated.vue?vue&type=script&lang=js"
import style0 from "./RequestViewTabRelated.vue?vue&type=style&index=0&id=21fb20e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports